import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AvatarComponent, IconComponent } from '@copado/cds';
import { NgbCollapseModule, NgbDropdownModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import { UserState } from '@app/auth/user.state';
import { ProjectState } from '@app/projects/project.state';
import { SearchComponent } from '@app/search/search.component';
import { CanUseService, Feature } from '@app/shared/can-use.service';
import { EnvironmentService } from '@app/shared/environment.service';
import { HelpBlockComponent } from '@app/shared/help-block/help-block.component';
import { Modal } from '@app/shared/modal/modal.model';
import { OrgSwitcherComponent } from '@app/shared/org-switcher/org-switcher.component';
import { getInitials } from '@app/shared/string.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AvatarComponent,
    HelpBlockComponent,
    IconComponent,
    NgbCollapseModule,
    NgbDropdownModule,
    NgbTooltip,
    OrgSwitcherComponent,
    RouterLink,
    SearchComponent,
  ],
  selector: 'app-main-nav',
  styleUrls: ['./main-nav.component.scss'],
  templateUrl: './main-nav.component.html',
})
export class MainNavComponent {
  private readonly canUseService = inject(CanUseService);
  protected readonly environment = inject(EnvironmentService);
  protected readonly projectId = inject(ProjectState).projectId;
  protected readonly userState = inject(UserState);

  protected isCollapsed = true;

  protected readonly Modal = Modal;

  protected readonly hasAnalytics = computed(() => this.canUseService.can(Feature.Analytics));
  protected readonly isSuperOrProvisioningAdmin = computed(
    () => this.userState.user()?.superAdmin ?? this.userState.user()?.provisioningAdmin ?? false,
  );
  protected readonly org = computed(() => this.userState.org());
  protected readonly userInitials = computed(() => getInitials(this.userState.user()?.name ?? ''));
  protected readonly userRole = computed(() =>
    this.userState.user()?.role.find((r) => this.userState.orgId() === r.organizationId),
  );
}
